import { Injectable } from '@angular/core';

@Injectable()
export class MockService {
  public events = [
    {
      id: '1',
      title: 'Event 1',
      start: '2020-02-19',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '2',
      title: 'Event 2',
      start: '2020-02-19T02:00:00',
      end: '2020-02-19T03:00:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '3',
      title: 'Event 3',
      start: '2020-02-19T05:00:00',
      end: '2020-02-19T07:00:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '4',
      title: 'Event 4',
      start: '2020-02-19T14:00:00',
      end: '2020-02-19T17:00:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '5',
      title: 'Event 5',
      start: '2020-02-21',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '6',
      title: 'Event 6',
      start: '2020-02-21',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '7',
      title: 'Event 7',
      start: '2020-02-21',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '8',
      title: 'Event 8',
      start: '2020-02-20T24:00:00',
      end: '2020-02-21T01:15:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '9',
      title: 'Event 9',
      start: '2020-02-21T02:00:00',
      end: '2020-02-21T03:00:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '10',
      title: 'Event 10',
      start: '2020-02-21T03:00:00',
      end: '2020-02-21T04:30:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '11',
      title: 'Event 11',
      start: '2020-02-21T04:50:00',
      end: '2020-02-21T06:30:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '12',
      title: 'Event 12',
      start: '2020-02-21T07:30:00',
      end: '2020-02-21T08:25:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '13',
      title: 'Event 13',
      start: '2020-02-22',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '14',
      title: 'Event 14',
      start: '2020-02-31',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '15',
      title: 'Event 15',
      start: '2020-02-31T02:30:00',
      end: '2020-02-31T04:25:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
    {
      id: '16',
      title: 'Event 16',
      start: '2020-02-31T07:30:00',
      end: '2020-02-31T08:25:00',
      color: '#00D6D6',
      backgroundColor: '#00D6D6',
      allDay: false,
      textColor: '#FFFFFF',
      extendedProps: {
        data: 'Data',
      },
    },
  ];

  public notification = {
    newNotificaitons: [
      {
        entityId: {
          code: '1809',
          id: '5e94301d352e9227ecc9e2f9',
        },
        title: '1089 - Tire Repairs',
        text: 'Techs have finished woring on Order # 1089',
        type: 'Estimate',
        estimate: {
          code: '1809',
          title: 'Tyre Repair',
        },
        isRead: false,
        isCritical: false,
        isFromTech: false,
        actions: [
          {
            action: 'dismiss',
            employeeId: '12324342',
            name: 'Send Invoice',
            date: '2020-04-21',
            completed: true,
          },
        ],
        destinationId: '45663452342',
        destinationType: 'payment',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
      {
        entityId: {
          code: '1809',
          id: '5e94301d352e9227ecc9e2f9',
        },
        title: '1089 - Tire Repairs',
        text: 'James has approved Order # 1809',
        type: 'Estimate',
        isRead: false,
        isCritical: false,
        isFromTech: false,
        actions: [
          {
            action: 'dismiss',
            employeeId: '12324342',
            name: 'Assign Tech',
            date: '2020-04-21',
            completed: true,
          },
        ],
        destinationId: '45663452342',
        destinationType: 'payment',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
      {
        entityId: {
          code: '1809',
          id: '5e94301d352e9227ecc9e2f9',
        },
        title: '1089 - Tire Repairs',
        text: 'Anderson has finished 120 points inspection on Mercedes 2020',
        type: 'Estimate',
        isRead: false,
        isCritical: false,
        isFromTech: false,
        actions: [
          {
            action: 'dismiss',
            employeeId: '12324342',
            name: 'Send Inspection',
            date: '2020-04-21',
            completed: true,
          },
        ],
        destinationId: '45663452342',
        destinationType: 'payment',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
      {
        entityId: {
          code: '1809',
          id: '5e94301d352e9227ecc9e2f9',
        },
        title: '1089 - Tire Repairs',
        text: 'Invoice 1089 has been unpaid for 3 days',
        type: 'Estimate',
        isRead: false,
        isCritical: false,
        isFromTech: false,
        actions: [
          {
            action: 'dismiss',
            employeeId: '12324342',
            name: 'View Order',
            date: '2020-04-21',
            completed: true,
          },
          {
            action: 'dismiss',
            employeeId: '12324342',
            name: 'Contact Customer',
            date: '2020-04-21',
            completed: true,
          },
        ],
        destinationId: '45663452342',
        destinationType: 'payment',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
      {
        entityId: {
          code: '10429',
          id: '5e931409a8fb750f3f367e99',
        },
        title: '10429 - Approve estimate',
        text:
          'James has received $66.0 in full payment from Mark Anderson (2010 Honda Civic)',
        type: 'Estimate',
        isRead: false,
        isCritical: false,
        isFromTech: false,
        actions: [
          {
            action: 'review',
            employeeId: '12324342',
            name: 'Send Review Request',
            date: '2020-04-21',
            completed: true,
          },
        ],
        destinationId: '45663452342',
        destinationType: 'payment',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
    ],
    today: [
      {
        entityId: '12232342342432',
        title: 'Not1',
        text: 'Mark Anderson updated company info',
        type: 'Settings',
        isRead: true,
        isCritical: false,
        isFromTech: false,
        actions: [{}],
        destinationId: '45663452342',
        destinationType: '',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
      {
        entityId: '12232342342432',
        title: 'Not1',
        text: `Arhan Shahid create a new part "Double Axle"`,
        type: 'Parts',
        isRead: false,
        isCritical: false,
        isFromTech: false,
        actions: [{}],
        destinationId: '45663452342',
        destinationType: '',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
      {
        entityId: '12232342342432',
        title: 'Not1',
        text: 'Deen Jones gave Stans Auto a 5 star review',
        type: 'Reviews',
        isRead: true,
        isCritical: false,
        isFromTech: false,
        actions: [
          {
            action: 'dismiss',
            employeeId: '12324342',
            name: `Reply to Mark's review`,
            date: '2020-04-21',
            completed: true,
          },
        ],
        destinationId: '45663452342',
        destinationType: 'payment',
        employee: {
          name: 'Alex Hales',
          employeeId: '556463534',
        },
      },
    ],
  };

  public logs = [
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Reviews',
      title: 'Google Reviews',
      description: 'Mark Stevenson gave Stans Auto a 5 star review',
    },
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Order',
      title: '1089 - Tire Repairs',
      description: 'Steven Clark approved Order # 1089',
    },
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Calendar',
      title: 'Appointment - Tire Change',
      description:
        'Appointment for Steven Clark (Mercedes S-class 2020) was scheduled for 3:00 pm, March 30, 2020',
    },
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Reviews',
      title: 'Google Reviews',
      description: 'Mark Stevenson gave Stans Auto a 5 star review',
    },
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Reviews',
      title: 'Google Reviews',
      description: 'Mark Stevenson gave Stans Auto a 5 star review',
    },
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Order',
      title: '1089 - Tire Repairs',
      description: 'Steven Clark approved Order # 1089',
    },
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Calendar',
      title: 'Appointment - Tire Change',
      description:
        'Appointment for Steven Clark (Mercedes S-class 2020) was scheduled for 3:00 pm, March 30, 2020',
    },
    {
      date: 'May 2, 2020 10:34 am',
      module: 'Reviews',
      title: 'Google Reviews',
      description: 'Mark Stevenson gave Stans Auto a 5 star review',
    },
  ];

  public modules = [
    {
      _id: '465465cb34343',
      name: 'Calendar',
    },
    {
      _id: '465465cb34343',
      name: 'Order',
    },
    {
      _id: '465465cb34343',
      name: 'Invoice',
    },
    {
      _id: '465465cb34343',
      name: 'Parts',
    },
    {
      _id: '465465cb34343',
      name: 'Reviews',
    },
  ];
  getCompany() {
    const token: any = {
      companyId: '23423423432',
      shopId: 'fsdfsdf',
      companyName: 'Autoleap',
      companyPhone: '45345423432',
      logo: '',
      userName: 'Test',
      role: 'tenant',
      stateCode: '',
      userId: '567454234324',
      emplyeeId: '453345453',
      timezone: '',
      qbo: false,
    };
    if (token) {
      return {
        companyId: token.companyId,
        shopId: token.shopId,
        companyName: token.name,
        companyPhone: token.phone,
        logo: token.logo,
        userName: token.fullName,
        role: token.role,
        stateCode: token.stateCode,
        userId: token.id,
        emplyeeId: token.employeeId,
        timezone: token.timezone,
        qbo: token['QBO'],
      };
    } else {
      return {};
    }
  }
}
